import { BaseComponent } from './baseComponent';

export class Accordion extends BaseComponent {
    private titles: HTMLElement[] = [];

    constructor(container: HTMLElement, options: Record<string, any>) {
        super(container, options);

        container.querySelectorAll('.accordion').forEach(accordion => {
            const title = accordion.querySelector('.accordion-title') as HTMLElement;
            const content = accordion.querySelector('.accordion-content') as HTMLElement;
            this.titles.push(title);

            title.addEventListener('keydown', this.handleKeydown.bind(this));
            title.addEventListener('click', this.toggle.bind(this));

            document.querySelectorAll(`[href="#${content.id}"], [data-href="#${content.id}"]`).forEach(linkTrigger => {
                if (linkTrigger.isEqualNode(title)) return;

                linkTrigger.addEventListener('click', (event: Event): void => {
                    event.preventDefault();
                    this.open(content);
                });
            });

            [accordion, title, content].forEach((element: HTMLElement) => {
                element.addEventListener('open', () => {
                    this.open(content);
                });
            });
        });

        this.onLoad();
    }

    toggle(event: MouseEvent|KeyboardEvent): void {
        event.preventDefault();
        const target = event.target as HTMLElement;
        const title = target.classList.contains('accordion-title')
            ? target
            : target.closest('.accordion-title');

        const content: HTMLElement = document.querySelector(title.getAttribute('href'));
        if (title.classList.contains('is-active')) {
            this.close(content);
        } else {
            this.open(content);
        }
    }

    open(content: HTMLElement): void {
        const title = this.container.querySelector(`.accordion-title[href="#${content.id}"]`);
        if (!this.options.allowMultipleOpen) {
            this.closeAll();
        }

        title.classList.add('is-active');
        title.setAttribute('aria-selected', 'true');
        title.setAttribute('aria-expanded', 'true');

        content.classList.add('is-active');
        content.removeAttribute('inert');

        setTimeout(() => {
            if (this.options.scrollToTitle) title.scrollIntoView();
        }, 500)

        this.afterOpen(content.id);
    }

    close(content: HTMLElement): void {
        const title = this.container.querySelector(`.accordion-title[href="#${content.id}"]`);

        title.classList.remove('is-active');
        title.setAttribute('aria-selected', 'false');
        title.setAttribute('aria-expanded', 'false');
        console.log('close', title)
        content.classList.remove('is-active');
        content.setAttribute('inert', 'true');

        this.afterClose(title.closest('.accordion').id);
    }

    closeAll() {
        this.container.querySelectorAll('.accordion-content').forEach((content: HTMLElement) => {
            this.close(content)
        })
    }

    handleKeydown(event: KeyboardEvent): void {
        const target = event.currentTarget;
        if (!(target instanceof HTMLElement)) return;
        let title: HTMLElement;

        switch (event.key) {
            case 'ArrowUp':
                title = (target.closest('.accordion').previousElementSibling)
                    ? target.closest('.accordion').previousElementSibling.querySelector('.accordion-title')
                    : null;
                break;

            case 'ArrowDown':
                title = (target.closest('.accordion').nextElementSibling)
                    ? target.closest('.accordion').nextElementSibling.querySelector('.accordion-title')
                    : null;
                break;

            case 'Home':
                title = this.titles[0];
                break;

            case 'End':
                title = this.titles[this.titles.length - 1];
                break;

            case 'Enter':
                this.toggle(event);
                break;

            case 'Escape':
                this.close(target)
                break;
        }

        if (title) title.focus();
    }

    public getDefaultOptions(options: Record<string, any> = {}) {
        const defaultOptions = {
            allowMultipleOpen: true,
            scrollToTitle: false,
        };
        return {
            ...super.getDefaultOptions(),
            ...defaultOptions,
            ...options,
        };
    }
}
